/* Copyright 2013 - 2024 Waiterio LLC */
import { useRoutes } from 'react-router'
import getRoutes from 'tagliatelle/getRoutes.jsx'
import context from './webpackContext.mjs'

const Routes = () => {
  let routes = getRoutes({ context })
  return useRoutes(routes)
}

export default Routes
